import BatteryPackRepair from './BatteryPackRepair';

export default BatteryPackRepair;
